import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import {
    getInterpsShortName,
    transformInterpToCSSClass,
} from '../../../common/utils/studentsListHelpers';
import { DIBELS8, IDEL2 } from '../../../constants/applications';
import { INTERPRETATIONS } from '../../../constants/interpretations';
import { localize } from '../../../common/localization';

export const getCompositeScore = (appName, student, period) => {
    const details = {
        [DIBELS8]: student.appStatuses.dibels8,
        [IDEL2]: student.appStatuses.idel2,
    };

    const studentDetails = details[appName][period];

    return (
        <CompositeScore
            interpretation={studentDetails && studentDetails.overallInterp}
            score={studentDetails && studentDetails.overallScore}
        />
    );
};

const getScoreContainer = (interpsShortName, score) => {
    switch (interpsShortName) {
        case INTERPRETATIONS.PAUSED:
            return (
                <div className='dashboard-pause'>
                    <div className='dashboard-vertical-line' />
                    <div className='dashboard-vertical-line' />
                </div>
            );
        case INTERPRETATIONS.UNKNOWN:
            return <div className='dashboard-hyphen' />;
        default:
            return <div className='dashboard-score'>{score}</div>;
    }
};

const getScoreInerpretation = interpsShortName => {
    switch (interpsShortName) {
        case INTERPRETATIONS.UNKNOWN:
            return (
                <div className='dashboard-score-interpretation'>
                    <div className='dashboard-hyphen' />
                </div>
            );
        case INTERPRETATIONS.PAUSED:
            return <div className='dashboard-paused-label'>{localize(interpsShortName)}</div>;

        default:
            return <div className='dashboard-score-interpretation'>{interpsShortName}</div>;
    }
};

const CompositeScore = ({ score, interpretation }) => {
    const interpsShortName = getInterpsShortName(interpretation) || INTERPRETATIONS.UNKNOWN;
    const interpsCssClass = transformInterpToCSSClass(interpsShortName);

    const cssClasses = classNames(
        // HACK: empty string is added for correct prefixing
        // issue https://github.com/vezetvsem/react-classname-prefix-loader/issues/3
        'dashboard-score-container',
        'dashboard-' + interpsCssClass,
    );

    return (
        <div className='dashboard-composite-score'>
            <div className={cssClasses}>{getScoreContainer(interpsShortName, score)}</div>
            {getScoreInerpretation(interpsShortName)}
        </div>
    );
};

CompositeScore.propTypes = {
    score: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
    interpretation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

CompositeScore.defaultProps = {
    score: null,
    interpretation: null,
};

export default CompositeScore;
